import { AuthenticatedHttp } from '@/http/axios';

export const BLACK_NOVEMBER_SLUG = 'black-november';

/**
 * Progresso do usuário numa campanha sazonal de premiação.
 *
 * O backend é a fonte única da janela: manda a fase já resolvida, com as datas
 * calculadas no fuso de Brasília para o ano corrente. O painel não recalcula
 * nada — se a regra de um ano mudar, muda lá e o front acompanha sem deploy.
 *
 * `sales`, `goal` e `missing` chegam como **string**: no universo backend o DRF
 * serializa `Decimal` assim (no split, como número). Quem consome converte.
 *
 * O erro sobe: quem chama decide o que fazer com ele. No header, a campanha
 * simplesmente não aparece.
 */
export const fetchCampaignProgressService = ({ slug, signal } = {}) =>
  AuthenticatedHttp.get(`/campaigns/${slug}/`, { signal }).then(({ data }) => data);
